import { useState, useEffect, useRef, useMemo, forwardRef } from 'react';
import { Card, Form, Container, Row, Col, Nav, Tab, InputGroup  } from 'react-bootstrap';

import {  RecoilRoot,
    atom,
    selector,
    useRecoilState,
    useRecoilValue} from 'recoil';
import useMessage from '../../Hooks/useMessage';
import usePaginationValuesWhere from '../../Hooks/usePaginationValuesWhere';
import { buscar } from '../../Utils/Buscar';
import { useAuthentication } from '../../Hooks';
import useExceptionHandler from '../../Hooks/useExceptionHandler';
import { AnimatedIconButton } from '../AnimatedIconButton/AnimatedIconButton';
import { GridView } from '../GridView/GridView';
import { DEFAULT_PAGINATION_VALUES, FUENTE_CUENTA, ReferidosAtom } from '../../Utils';
import uuid from 'react-uuid';
import Select from 'react-select'
import {OBTENER_REFERIDOS_MI_CUENTA} from "../../../../Seguridad/Scripts/Utils/urls";

const ESTATUS_ACTIVA = "A";
const ESTATUS_INACTIVA = "I";
const ESTATUS_ACTIVA_LABEL = "Activa";
const ESTATUS_INACTIVA_LABEL = "Inactiva";

export function ReferidosSection(){
    const consultaActualId = useRef();
    const [pagination, setPagination] = useState({
        ...DEFAULT_PAGINATION_VALUES,
    });
    const ESTATUS_LIST = [
        { value: "", label: "Todos" },
        {
            value: ESTATUS_ACTIVA,
            label: ESTATUS_ACTIVA_LABEL,
        },
        {
            value: ESTATUS_INACTIVA,
            label: ESTATUS_INACTIVA_LABEL,
        },
    ]
    const [referidosState, setReferidosState] = useRecoilState(ReferidosAtom)
    const { setPaginationValuesWhere } = usePaginationValuesWhere();
    const [whereModal, setWhereModal] = useState({});
    const [referidosList, setReferidosList] = useState(null);
    const [referidosAcitvosCount, setReferidosActivosCount] = useState(0);
    const [referidosInacitvosCount, setReferidosInactivosCount] = useState(0);
    const [referidosAcitvosLicenciasCount, setReferidosActivosLicenciasCount] = useState(0);
    const [referidosInacitvosLicenciasCount, setReferidosInactivosLicenciasCount] = useState(0);
    const [licenciasPlan1, setLicenciasPlan1] = useState(0)
    const [licenciasPlan2, setLicenciasPlan2] = useState(0)
    const [referidosPlan1, setReferidosPlan1] = useState(0)
    const [referidosPlan2, setReferidosPlan2] = useState(0)
    const {Message} = useMessage();
    const [dateTimeKey, setDateTimeKey] = useState("fechasKey");
    const { handleException } = useExceptionHandler();
    const { usuario } = useAuthentication();

    const onPageIndexChanging = (pageNumber) => {
        setPagination((prevstate) => {
            return { ...prevstate, IndiceDePagina: pageNumber - 1 };
        });
        setWhereModal({ ...whereModal });
    };
    const handleClick = (params) => {
        const { Id, Clonar } = params;
        let urlBase = `/CuentaView`;
        if (!Id || Clonar) {
            urlBase = "/CuentaEdit";
        }
    };


    const [linkReferido, setLinkReferido] = useState('');
    useEffect(() => {
        const whereWithPaginationValues = { ...whereModal, ...pagination };
        const obtenerDatos = () => {
            const consultaId = Math.random();
            consultaActualId.current = consultaId;
            const url = OBTENER_REFERIDOS_MI_CUENTA;
            buscar(url, { }).then((data) => {
                if (consultaId === consultaActualId.current) {
                    setPaginationValuesWhere(data, pagination, setPagination);
                    setReferidosList(data.Resultados);
                    setLinkReferido(data.linkReferido);
                    setReferidosActivosCount(data.ReferidosActivos);
                    setReferidosInactivosCount(data.ReferidosInactivos);
                    setReferidosActivosLicenciasCount(data.ReferidoActivoLicencias);
                    setReferidosInactivosLicenciasCount(data.ReferidosInActivosLicencias);
                    setLicenciasPlan1(data.LicenciasPlan1);
                    setLicenciasPlan2(data.LicenciasPlan2);
                    setReferidosPlan1(data.referidosPlan1);
                    setReferidosPlan2(data.referidosPlan2);
                    setReferidosState(data.Resultados)
                }
            }).catch((error) => {
                handleException(error);
            }).finally(() => {
            });
        };
        obtenerDatos();
    }, [whereModal]);
    
    return(
        <>
        {!usuario?.Compania?.Configuracion.EsCompaniaPrueba && (
            <Container>
                <div className='d-flex justify-content-center align-content-center flex-column'>
                    <h2 className='text-center text-muted'>Mi Enlace para Referir</h2>
                    <h5 className='text-center'>{linkReferido}</h5>
                    <AnimatedIconButton
                        style2={{display: 'flex', justifyContent: 'center'}}
                        onClick={() => {
                            navigator.clipboard.writeText(linkReferido)
                            Message({message: 'Enlace copiado'})
                        }}
                        size="35px"
                        height="20px"
                        width="20px"
                        message="Copiar Enlace"
                        iconName="copy"
                        isWhite={true}
                    />
                    <small className='text-muted text-center mb-4'>Haz click en el icono para copiar tu enlace</small>
                    <h2 className='text-center text-muted'>Todos mis referidos</h2>
                    <Row>
                        <Col>
                            <h6 className='text-center'>Referidos Activos: {referidosAcitvosCount}</h6>
                            <h6 className='text-center'>Licencias: {referidosAcitvosLicenciasCount}</h6>
                        </Col>
                        <Col>
                            <h6 className='text-center'>Referidos Inactivos: {referidosInacitvosCount}</h6>
                            <h6 className='text-center'>Licencias: {referidosInacitvosLicenciasCount}</h6>
                        </Col>
                    </Row>
                    <h2 className='text-center text-muted'>Beneficios por Plan</h2>
                    <Row>
                        <Col>
                            <div style={{fontSize:'1.5rem'}} className='text-center text-muted'>Plan 1</div>
                            <h6 className='text-center'>Referidos Activos: {referidosPlan1}</h6>
                            <h6 className='text-center'>Licencias Gratuitas: {licenciasPlan1}</h6>
                        </Col>
                        <Col>
                            <div style={{fontSize:'1.5rem'}} className='text-center text-muted'>Plan 2</div>
                            <h6 className='text-center'>Referidos Activos: {referidosPlan2}</h6>
                            <h6 className='text-center'>Licencias Gratuitas: {licenciasPlan2}</h6>
                        </Col>
                    </Row>
                </div>

                <GridView
                    allowPaging={false}
                    dataSource={referidosList}
                    hideFilters={true}
                    fuente={FUENTE_CUENTA}
                    onReset={() => {
                        setDateTimeKey(uuid());
                    }}
                >
                    <GridView.Column
                        headerText="Nombre de Referido"
                        dataField="Nombre"
                        sortExpression="Nombre"
                    />
                    <GridView.Column
                        headerText="Plan"
                        dataField="_TipoPlanReferido"
                        sortExpression="_TipoPlanReferido"
                    />
                    <GridView.Column
                        headerText="Estatus"
                        dataField="_EstatusDesc"
                        sortExpression="Estatus"
                        width="150px"
                        filterRenderer={(onInputChange) => {
                            return (
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    options={ESTATUS_LIST}
                                    value={ESTATUS_LIST.filter(function (option) {
                                        return (
                                            option.value ===
                                            (whereModal.Estatus ? whereModal.Estatus : ESTATUS_LIST[0].value)
                                        );
                                    })}
                                    name="Estatus"
                                    onChange={(e) =>
                                        onInputChange({ target: { name: "Estatus", value: e.value } })
                                    }
                                />
                            );
                        }}
                    />
                </GridView>
            </Container>
            )}
        </>
    )
}